export default __webpack_public_path__ + "static/media/air-cooled-chiller.f4f4bfe9.png";